// extracted by mini-css-extract-plugin
module.exports = {"grid":"_ee7faca","gridLinkedImg":"_6a66c92","image":"_acedc99","gridText":"_920eb36"};